import { render, staticRenderFns } from "./AdPayBLPaymentTarget.vue?vue&type=template&id=5071abd6&scoped=true&class=bl_payment_pop"
import script from "./AdPayBLPaymentTarget.vue?vue&type=script&lang=js"
export * from "./AdPayBLPaymentTarget.vue?vue&type=script&lang=js"
import style0 from "./AdPayBLPaymentTarget.vue?vue&type=style&index=0&id=5071abd6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5071abd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5071abd6')) {
      api.createRecord('5071abd6', component.options)
    } else {
      api.reload('5071abd6', component.options)
    }
    module.hot.accept("./AdPayBLPaymentTarget.vue?vue&type=template&id=5071abd6&scoped=true&class=bl_payment_pop", function () {
      api.rerender('5071abd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/AdPayBLPaymentTarget.vue"
export default component.exports